import { v4 as uuidv4 } from 'uuid';

import { datadogLogger } from '@telialt/utils/src/datadog/datadogLogger';
import { DDComponent } from '@telialt/utils/src/datadog/setup';

import { apiPostSearchEvents } from '../api';
import { SEARCH_SESSION_ID_KEY } from '../constants';

const getSearchSessionId = () => {
    const sessionId = sessionStorage.getItem(SEARCH_SESSION_ID_KEY);
    if (sessionId) {
        return sessionId;
    }
    const newSessionId = uuidv4();
    sessionStorage.setItem(SEARCH_SESSION_ID_KEY, newSessionId);

    return newSessionId;
};

export const handleLupaSearchEvent = async (
    name: 'itemClick' | 'suggestionClick',
    queryKey: string,
    searchQuery: string,
    itemId: string,
) => {
    const sessionId = getSearchSessionId();

    try {
        await apiPostSearchEvents({ queryKey, name, searchQuery, itemId, sessionId });
    } catch (error) {
        datadogLogger().warn(
            'Failed LupaSearch event tracking',
            {
                component: DDComponent.Search,
            },
            error,
        );
    }
};
